import * as remoteConfigFetch from './remote-config';
export var createRemoteConfigFetch = remoteConfigFetch.createRemoteConfigFetch;
//# sourceMappingURL=index.js.map